export default __webpack_public_path__ + "static/media/dozule4.d63d679b.jpg";